import { render, staticRenderFns } from "./inviteProxyReg.vue?vue&type=template&id=3017208e&"
import script from "./inviteProxyReg.vue?vue&type=script&lang=js&"
export * from "./inviteProxyReg.vue?vue&type=script&lang=js&"
import style0 from "./inviteProxyReg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports